import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import idx from 'idx';
import PAPPayment from 'pap/components/payment';
import {
  fetchLeadSourcesIfNeeded, updateUserRequest, fetchCountriesIfNeeded, fetchCurrentUser
} from 'common/ducks/user';
import { fetchProjectIfNeeded, updateProjectLocal } from 'project/ducks/project';
import { updateProjectRequest } from 'pap/ducks/project';
import { fetchMethodIfNeeded } from 'common/ducks/billing';
import { assureProjectRequest } from 'pap/ducks/pricing';
import { getProjectIdFromUrl } from 'project/utils';
import { getSubCategoryFromProject, getCategoryFromProject } from 'pap/utils';

export function mapStateToProps(state, { params }) {

  /* this component may be either in PAP or in the project page (for 1-1 projects),
     so we need to handle the extraction of the project ID from the URL in both cases */
  let projectID = params.projectID  // PAP URL
  let isProjectPage = false
  if (!projectID) {
    projectID = getProjectIdFromUrl(params) // project page URL
    isProjectPage = true
  }

  const projectData = state.pap.project.projectData
  const assured = projectData? projectData.assured : false
  const user = state.user.profile_data
  const initialValues = {
    /* 1-1 projects are always assured, so user must explicitly confirm */
    assured_confirmed: idx(projectData, _ => _.is_one_to_one)? false : assured,
    ...user
  }
  const method = state.billing.method

  return {
    categories: state.categories,
    projectData: projectData,
    category: getCategoryFromProject(projectData, state.categories) || {},
    subCategory: getSubCategoryFromProject(projectData, state.categories) || {},
    leadSources: state.user.leadSources,
    countries: state.user.countries,
    user: user,
    initialValues: initialValues,
    fetchingMethod: method === undefined,
    projectID,
    isProjectPage,
    method,
    assured
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchLeadSourcesIfNeeded,
    fetchCountriesIfNeeded,
    fetchProjectIfNeeded,
    updateProjectRequest,
    updateProjectLocal,
    updateUserRequest,
    assureProjectRequest,
    fetchMethodIfNeeded,
    fetchCurrentUser,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'pap_payment',
    /* allow the form the reinitialize with new "pristine" values every time
       the initialValues prop changes, e.g. initial values may be loaded after the form
       is initialized */
    enableReinitialize: true
  })(PAPPayment)
), { withRef: true });



// WEBPACK FOOTER //
// ./pap/containers/payment.jsx